import type { IntegrationConnectionHealthCheckType } from '@/api/integration';

import HealthCheckError from './HealthCheckError';

type Props = {
  healthCheck: IntegrationConnectionHealthCheckType;
};

const HealthCheckDefaultError = ({ healthCheck }: Props) => {
  return (
    <HealthCheckError
      title={
        <>
          <b>{healthCheck.name}:</b> {healthCheck.description}
        </>
      }
    />
  );
};

export default HealthCheckDefaultError;
